import { NgIf, NgStyle } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-hero',
  standalone: true,
  imports: [ButtonModule, TranslocoDirective, NgStyle, NgIf],
  templateUrl: './hero.component.html',
  styleUrl: './hero.component.scss',
})
export class HeroComponent implements OnInit {
  @Input() text!: { [key: string]: string | {} | null };
  @Input() template!: string;
  @Input() functionsMap!: { [key: string]: () => void };
  data: any = {};
  products: any[] | undefined;
  platform: string;

  constructor() {
    this.platform = Capacitor.getPlatform();
  }

  executeFunction(funcName: string): void {
    this.functionsMap?.[funcName]
      ? this.functionsMap[funcName]()
      : console.warn(
          `Funzione "${funcName}" non trovata nella mappa delle funzioni o non è valida.`,
        );
  }

  ngOnInit(): void {
    this.data = this.text;
  }
}
